import { render } from "./RadialChart.vue?vue&type=template&id=35579a54"
import script from "./RadialChart.vue?vue&type=script&lang=js"
export * from "./RadialChart.vue?vue&type=script&lang=js"

import "./RadialChart.vue?vue&type=style&index=0&id=35579a54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__